var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsBorderLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99967 8.66665C2.92015 8.66665 3.66634 7.92045 3.66634 6.99998C3.66634 6.0795 2.92015 5.33331 1.99967 5.33331C1.0792 5.33331 0.333008 6.0795 0.333008 6.99998C0.333008 7.92045 1.0792 8.66665 1.99967 8.66665Z",
    fill: "#112538"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99967 3.66665C2.92015 3.66665 3.66634 2.92045 3.66634 1.99998C3.66634 1.0795 2.92015 0.333313 1.99967 0.333313C1.0792 0.333313 0.333008 1.0795 0.333008 1.99998C0.333008 2.92045 1.0792 3.66665 1.99967 3.66665Z",
    fill: "#112538"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99967 13.6666C2.92015 13.6666 3.66634 12.9205 3.66634 12C3.66634 11.0795 2.92015 10.3333 1.99967 10.3333C1.0792 10.3333 0.333008 11.0795 0.333008 12C0.333008 12.9205 1.0792 13.6666 1.99967 13.6666Z",
    fill: "#112538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsBorderLess);
export default __webpack_public_path__ + "static/media/dotsBorderLess.0bbc6fc8e1ea65dd449d179fd2f1c770.svg";
export { ForwardRef as ReactComponent };